import type { FeatureEvents, ScreenEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject } from '../new-analytics-types';

type ScreenKeys = 'loginCustomisationFormScreen';

type UiKeys = 'updateLoginCustomisationPolicy';

interface GuardSubscriptionAttributes {
  guardAccess: string;
}

export enum LoginCustomisationScreens {
  loginCustomisationFormScreen = 'loginCustomisationFormScreen',
}

export const loginCustomisationEvents: FeatureEvents<ScreenKeys, UiKeys, string, string> = {
  confluenceSpec:
    'https://hello.atlassian.net/wiki/spaces/~70121ad71b5e5ae3945878aece760df0466f2/pages/5144250187/Social+Login+Analytics+spec',
  screen: {
    loginCustomisationFormScreen: (attributes: GuardSubscriptionAttributes): ScreenEvent => ({
      data: {
        name: LoginCustomisationScreens.loginCustomisationFormScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/80738',
    }),
  },

  ui: {
    updateLoginCustomisationPolicy: (attributes: GuardSubscriptionAttributes): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'updateLoginCustomisationPolicy',
        source: LoginCustomisationScreens.loginCustomisationFormScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/80731',
    }),
  },

  track: {},

  operational: {},
};
